import { render, staticRenderFns } from "./SelectValue.vue?vue&type=template&id=65d1093a&"
import script from "./SelectValue.vue?vue&type=script&lang=js&"
export * from "./SelectValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports